import React from "react";
import TableHeader from "../Utility/TableHeader";
import { EyeIcon } from "lucide-react";
import { Tooltip } from "react-tooltip";
import { Pagination } from "../../helper/HelperTwo";
import axios from "axios";
import DeleteConfirmation from "../Utility/DeleteConfirmation";
import { toast } from "react-toastify";

function LeadProductsList({
  setLoading,
  setIsEditing,
  setSaveBtn,
  setProductsInputs,
  setEditProductIdCrypt,
  setProductsDialogOpen,
  paginationProductsDatas,
  fetchProducts,
  setCurrentPage,
  productPermission,
  filterParams,
}) {
  const headers = ["S No", "Product Name", "Count", "Product Cost", "Actions"];

  const handlePageChange = (page) => {
    if (page !== "..." && !isNaN(page)) { 
      const newPage = Number(page);
      setCurrentPage(newPage);
      fetchProducts(newPage, filterParams);
    }
  };

  const handleViewForProducts = async (id_crypt) => {
    setLoading(true);
    setProductsDialogOpen(true);
    setEditProductIdCrypt(id_crypt);
    await fetchProducts();
    setIsEditing(true);
    setSaveBtn("update");

    try {
      const response = await axios.get(
        `public/api/admin/product/edit/${id_crypt}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (response.data) {
        setProductsInputs((prevList) => ({
          ...prevList,
          product_name: response.data.product.product_name,
          product_type: response.data.product.product_type,
          code_type: response.data.product.code_type,
          product_cost: response.data.product.product_cost,
          price_bill_type: response.data.product.price_bill_type,
          count: response.data.product.count,
          product_description: response.data.product.product_description,
        }));
      }
      setProductsInputs(response.data.product);
    } catch (err) {
      toast.error(err.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="overflow-x-auto w-full">
        <table className="min-w-full divide-y divide-gray-300 mt-8">
          <TableHeader headers={headers} />

          <tbody className="divide-y divide-gray-200 bg-white">
            {paginationProductsDatas?.data?.map((product, index) => (
              <tr
                key={index}
                className="hover:bg-gray-50 uppercase text-mdion duration-300 ease-in-out"
              >
                <td className="whitespace-nowrap text-md  px-4 text-center">
                  {paginationProductsDatas.from + index}
                </td>
                <td className="whitespace-nowrap  text-md text-gray-500 px-4 text-center">
                  {product.product_name}
                </td>
                <td className="whitespace-nowrap text-md text-gray-500 px-4 text-center">
                  {product.count}
                </td>
                <td className="whitespace-nowrap text-md text-gray-500 px-4 text-center">
                  {product.product_cost.split(".")[0]}
                </td>

                <td className=" border-gray-200 px-6 py-4 text-center flex justify-center items-center gap-2">
                  {productPermission && (
                    <span
                      className="my-anchor-view relative group cursor-pointer bg-blue-400 rounded-md p-1"
                      onClick={() => handleViewForProducts(product.id_crypt)}
                    >
                      <EyeIcon className="h-5 w-5 text-white" />
                      <Tooltip
                        anchorSelect=".my-anchor-view"
                        place="top"
                        className="text-xs p-0"
                        style={{ fontSize: "12px", padding: "0.3rem" }}
                      >
                        View
                      </Tooltip>
                    </span>
                  )}
                  {productPermission && (
                    <DeleteConfirmation
                      id_crypt={product.id_crypt}
                      apiType={"product"}
                      fetchClientData={fetchProducts}
                      setLoading={setLoading}
                    />
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {paginationProductsDatas && (
        <Pagination
          links={paginationProductsDatas.links}
          currentPage={paginationProductsDatas.current_page}
          totalResults={paginationProductsDatas.total}
          from={paginationProductsDatas.from}
          to={paginationProductsDatas.to}
          lastPage={paginationProductsDatas.last_page}
          onPageChange={handlePageChange}
        />
      )}
    </div>
  );
}

export default LeadProductsList;
